import styled from "styled-components";

export const ContentWrapper = styled.section`
  @media (min-width: 1200px) {
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
`;
